import * as _4 from 'lodash4';
export class PlacementGroup {
  section: any;
  nk: string;
  graphs: any = [];

  constructor(private phxFeatureConfiguration: any) {}

  $onInit(): void {
    this.initializeGraphs();
  }

  hasCourses(): boolean {
    return !_4.isEmpty(this.section._courses_by_group_nk[this.nk]);
  }

  hasTests(): boolean {
    return !_4.isEmpty(this.section._tests);
  }

  numCoursesInSection(): number {
    return _4.flatten(_4.values(this.section._courses_by_group_nk)).length;
  }

  isHighestBand(): boolean {
    return _4.isEmpty(this.section.next_highest_path_entry_by_group_nk[this.nk]);
  }
  numPlacementGroups(): number {
    return _4.keys(this.section._courses_by_group_nk).length;
  }

  hasTestsOnPath(): boolean {
    return !_4.isEmpty(this.section._tests_on_path);
  }

  isTestOnPath(test: any): boolean {
    return _4.includes(this.section._tests_on_path, test);
  }
  scoresToDegrees(score: number, maxScore: number): number {
    return -Math.round((score / maxScore) * 360);
  }
  hasBestTestsOffPath(): boolean {
    let testsExist = false;

    angular.forEach(this.section._best_tests_by_nk, (test) => {
      testsExist = testsExist || _4.includes(this.section._tests_off_path, test);
    });

    return testsExist;
  }

  /*tslint:disable:cognitive-complexity*/
  initializeGraphs() {
    // If there are no tests, return an empty array...
    if (!this.hasTests()) {
      return this.graphs;
    }

    const isHighestBand = this.isHighestBand();
    const hasCourses = this.hasCourses();
    const numPlacementGroups = this.numPlacementGroups();

    _4.each(this.section._best_tests_by_nk[this.nk], (test) => {
      const name = test.name;
      const score = test.score;
      const maxScore = test.max_score;
      const bands: any = [];

      // Check if test is on the path...
      const isTestOnPath = this.isTestOnPath(test);

      // If the student is in the highest placement band for the specified section, he should see
      // a green graph.
      if (isHighestBand || !hasCourses) {
        bands.push({
          degrees: this.scoresToDegrees(score, maxScore),
          color: numPlacementGroups === 1 ? 'college-ready' : 'dev-req'
        });
      }

      // If the student is not in the highest placement band, and the test is not on the path out,
      // then he should see a blue graph.
      else if (!(isHighestBand || !hasCourses) && !isTestOnPath) {
        bands.push({
          degrees: this.scoresToDegrees(score, maxScore),
          color: 'dev-req'
        });
      }

      // If the student is not in the highest placement band and the test is on the path out, he
      // see a graph with an orange band and a blue band.
      else {
        const entry = this.section.next_highest_path_entry_by_group_nk[this.nk];

        bands.push({
          degrees: this.scoresToDegrees(entry.min_score, maxScore),
          color: 'next-band'
        });
        bands.push({
          degrees: this.scoresToDegrees(score, maxScore),
          color: 'dev-req'
        });
      }

      // Build graph data...
      this.graphs.push({
        name,
        score: _4.parseInt(score),
        bands,
        test
      });
    });

    // Check if we need separate graph to show the next highest path entry...
    if (
      (!isHighestBand && !this.hasTestsOnPath()) ||
      (!isHighestBand && this.hasBestTestsOffPath() && this.hasTestsOnPath())
    ) {
      const entry = this.section.next_highest_path_entry_by_group_nk[this.nk];

      const bands = [
        {
          degrees: this.scoresToDegrees(entry.min_score, entry.test_max_score),
          color: 'next-band'
        }
      ];

      const entryTest: any = _4.find(this.section._tests, {
        id: entry.test_id
      });

      if (entryTest) {
        bands.push({
          degrees: this.scoresToDegrees(entryTest.score, entry.test_max_score),
          color: 'dev-req'
        });
      }

      this.graphs.push({
        name: entry.test_name,
        score: _4.parseInt(entry.min_score),
        bands,
        test: undefined
      });
    }

    return this.graphs;
  }
}

angular.module('biz-ng-path-placement').component('placementGroup', {
  bindings: {
    section: '<',
    nk: '<'
  },
  controller: PlacementGroup,
  templateUrl: 'biz-ng-path-placement/src/components/placement_group/placement_group.html'
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/components/placement_group/placement_group.ts